import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

export function initPostHog() {
  if (!POSTHOG_KEY || !POSTHOG_HOST) {
    console.warn('PostHog not configured - missing env vars');
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    loaded: () => {
      if (import.meta.env.DEV) {
        console.log('PostHog loaded');
      }
    },
  });
}

export { posthog };
